import React from 'react';
export function GuaranteeSection() {
  return <section className="w-full bg-bg-main py-16 sm:py-24 px-4" data-id="element-110">
      <div className="max-w-3xl mx-auto text-center" data-id="element-111">
        <div className="text-5xl sm:text-6xl mb-6" data-id="element-112">🛡️</div>

        <h2 className="text-2xl sm:text-4xl font-serif font-black text-text-main mb-6 uppercase" data-id="element-113">
          SATISFACTION GUARANTEE
        </h2>

        <p className="text-text-sec text-base sm:text-lg leading-relaxed font-medium max-w-2xl mx-auto mb-8" data-id="element-114">
          7-day no-questions-asked guarantee. If the tactical blueprints don't
          save you time or improve your team's game, we refund 100%.
        </p>

        <a href="#" className="text-primary font-medium text-sm hover:underline" data-id="element-115">
          Full Refund Policy
        </a>
      </div>
    </section>;
}